<template>
  <ul class="fw-frame-list">
    <p v-if="list.length === 0" class="empty">
      暂无数据
    </p>
    <li v-for="person in list" v-else :key="person.id" :title="personInfo(person)" :class="getClass(person)"
      class="fw-frame-one" @click="itemClick(person)">
      <span class="one-name">{{ person.name }}({{ person.username }})</span>
      <span class="one-info">
        <span v-if="person.telNum" class="mr-8">
          <i class="el-icon-phone"></i> {{ person.telNum }}</span>
        <span v-if="person.staffID" class="mr-8"><i class="el-icon-s-cooperation"></i>{{ person.staffID }}</span>
      </span>
    </li>
  </ul>
</template>
<script>
export default {
  name: "FwUlBox",
  inheritAttrs: false,
  props: {
    // 选中的列表名
    activeListName: { default: "", type: String },
    // 正常的数据
    // 被禁用的数据
    disabledList: { default: () => [], type: Array },
    findPersonIndex: { default: () => () => {}, type: Function },
    list: { default: () => [], type: Array }
  },
  methods: {
    personInfo(person) {
      return `${person.name}\n${person.staffID ? `工号:${person.staffID}\n` : ""}${
        person.postName ? `岗位:${person.postName}\n` : ""
      }${person.telNum ? `联系方式:${person.telNum}\n` : ""}${
        person.roleInfos && person.roleInfos.length ? `角色:${person.roleInfos.map(({ roleName }) => roleName)}\n` : ""
      }`;
    },
    itemClick(person) {
      const { activeListName } = this;
      this.$emit("item-click", person, activeListName);
    },
    getClass(person) {
      const { findPersonIndex, activeListName, disabledList } = this;
      return {
        checked: findPersonIndex(person, activeListName) !== -1,
        disabled: disabledList.some(({ userId }) => userId === person.userId)
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.empty {
  font-size: 14px;
  margin-top: 80px;
  color: var(--info-color);
  font-weight: normal;
  text-align: center;
}
.fw-frame-one.disabled {
  opacity: 0.5;
  cursor: no-drop;
  pointer-events: none;
}
</style>
